import { ResourceRequestStatus } from '~/types';

export const checkIfResourceAllocationIsReadOnly = ({ resourceRequest }) => ({
  isResourceAllocationReadOnly:
    resourceRequest.requestStatus === ResourceRequestStatus.Complete ||
    resourceRequest.requestStatus === ResourceRequestStatus.Tentative
});
